export default __webpack_public_path__ + "static/media/mg-img.65209bc7.webp";